import { render, staticRenderFns } from "./PermissionsGroups.vue?vue&type=template&id=38033714&scoped=true&"
import script from "./PermissionsGroups.vue?vue&type=script&lang=js&"
export * from "./PermissionsGroups.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsGroups.vue?vue&type=style&index=0&id=38033714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38033714",
  null
  
)

export default component.exports